var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"learning-chart"},[_c('image-base',{staticClass:"learning-chart__image",attrs:{"src":_vm.systemChartDetail.imageUrl}}),_vm._l((_vm.systemChartDetail.units),function(systemChartUnit){return [_c('learning-chart-unit',{attrs:{"systemChartUnit":systemChartUnit,"onSelectUnit":_vm.onSelectUnit}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }